"use strict";

const AssetRoutineMaintenanceSample = function (Controller) {
  const stringKey = "sample";
  const tabHeader = "Sample Collection";
  let $page;

  var loadListeners = function (data) {
    if (!$page) {
      $page = $(`#assessment-modal #${stringKey}`);
    }

    $page.on("2N:FormInput", `[name="collect-samples"]`, onCollectSamplesChange);
    $page.on("click", ".save-btn", _saveNewSample);
    $page.on("click", ".delete-btn", deleteExistingSample);

    if (data) {
      toggleCollectSamples(data.collectSamples);
    }
  };

  var unloadListeners = function () {
    $page.off("2N:FormInput", `[name="collect-samples"]`, onCollectSamplesChange);
    $page.off("click", ".save-btn", _saveNewSample);
    $page.off("click", ".delete-btn", deleteExistingSample);
  };

  var getProps = function () {
    return {
      methodOptions: DryWeatherConstants.getSampleMethodOptions(),
      locationCollectedFromOptions: DryWeatherConstants.getLocationCollectedFromOptions(),
    };
  };

  var getStringKey = function () {
    return stringKey;
  };

  var getTabHeader = function () {
    return tabHeader;
  };

  var _saveNewSample = function () {
    const newSample = Controller.getFormData(["newSample"]) || {};
    if (newSample.locationCollectedFrom && newSample.sampleId) {
      const sampleIdIsUnique = (Controller.getInspectionRenderData().samples || [])
        .filter((sample) => sample.deleted !== "true")
        .every((sample) => {
          return sample.sampleId !== newSample.sampleId;
        });
      if (!sampleIdIsUnique) {
        MessageModal.showSimpleWarningModal("Sample ID must be unique.");
        return;
      }

      const newRecord = {
        id: Date.now(),
        method: newSample.method || "grab-sample",
        locationCollectedFrom: newSample.locationCollectedFrom,
        sampleId: newSample.sampleId,
      };

      const totalSamples = Controller.getInspectionRenderData().samples || [];
      Controller.setFormData(["samples", totalSamples.length], newRecord);
      resetSampleFields();
      insertNewSampleRecordHtml(newRecord);
    } else {
      MessageModal.showSimpleWarningModal("Enter a value for all fields to save.");
    }
  };

  var deleteExistingSample = function (e) {
    const existingSamples = Controller.getExistingInspectionData().samples || [];
    const existingSampleIds = existingSamples.map((sample) => sample.id);
    const idToDelete = parseInt($(e.currentTarget).parent(".sample").attr("id"));
    if (existingSampleIds.includes(idToDelete)) {
      const existingIndex = existingSamples.findIndex((sample) => {
        return sample.id === idToDelete;
      });
      Controller.setFormData(["samples", existingIndex], {
        id: idToDelete,
        deleted: "true",
      });
    } else {
      const samples = Controller.getInspectionRenderData().samples;
      const newIndex = samples.findIndex((sample) => {
        return sample?.id === idToDelete;
      });
      Controller.unsetFormData(["samples", newIndex]);
    }
    $(e.currentTarget).parent(".sample").remove();
  };

  var onCollectSamplesChange = function (e, collectSamples) {
    toggleCollectSamples(collectSamples);
  };

  var toggleCollectSamples = function (collectSamples) {
    $page.find(`.show-when-collect-samples`).toggle(collectSamples);
  };

  var insertNewSampleRecordHtml = function (newRecord) {
    const html = nunjucks.render("modals/assetRoutineMaintenance/sampleRecord.njk", {
      record: newRecord,
    });
    $page.find(".sample-records").prepend(html);
  };

  var resetSampleFields = function () {
    const initialSampleFields = {
      method: "grab-sample",
    };
    $page.find(`[name="new-sample[method]"]`).val(initialSampleFields.method);
    $page.find(`[name="new-sample[location-collected-from]"]`).prop("checked", false);
    $page.find(`[name="new-sample[sample-id]"]`).val("");
    Controller.setFormData(["newSample"], initialSampleFields);
  };

  return {
    loadListeners,
    unloadListeners,
    getStringKey,
    getTabHeader,
    getProps,
    _saveNewSample,
  };
};

module.exports = AssetRoutineMaintenanceSample;

const DryWeatherConstants = require("../../illicitDischarge/dryWeatherScreening/dryWeatherConstants");
const MessageModal = require("../../modals/messageModal");
